<template>
  <div id="formDialog_root" >
    <div id="leftContain">
      <note-card
          v-for="note in notes"
          :key="note.title"
          :title="note.title"
          :info="note.info"
          @onClose="closeNote"
          class="noteCard">
      </note-card>
    </div>
    <el-dialog
        id="formDialog"
        :visible.sync="this.openAddModel"
        :before-close="this.closeAddModel"
        :modal-append-to-body="false"
        width="770px"
    >
      <span slot="title">
        {{title?title:'提示'}}
        <el-tooltip class="item" effect="light" content="打开模型图" placement="top-start">
          <el-button
              v-show="this.modelImages&&this.modelImages.length>0"
              class="titleBtn"
              icon="el-icon-picture"
              @click="openModelImages" circle></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="light" content="重置表单" placement="top-start">
          <el-button
              class="titleBtn"
              icon="el-icon-refresh"
              @click="handlerRefresh" circle></el-button>
        </el-tooltip>

      </span>
      <div style="margin-left:45px" id="dialog_body">
        <el-form :inline="true"
                 status-icon
                 label-position="left"
                 label-width="105px"
                 size="mini"
                 :model="data"
                 :rules="rules"
                 ref="modelForm"
                 style="z-index: 5006"
        >
          <el-row class="form_box" v-for="(boxTitle,index_a) in this.boxes" :key="index_a"  :title="'● '+ boxTitle">
            <el-col :span="12">
              <el-form-item  v-for="(item,index_b) in leftList[boxTitle]"
                             :key="index_b"
                             :label="item.label"
                             :prop="item.name"
              >
                <el-select  v-if="options[item.name]"
                            placeholder="请选择"
                            v-model="data[`${item.name}`]"
                            no-data-text="正在加载数据中..."
                >
                  <el-option v-for="child in options[item.name]"
                             :key="child"
                             :label="child+' '+item.unit"
                             :value="child">
                    <span style="float: left" >{{ child===''?'等待数据加载中...':child }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;padding-right:5px"
                          v-if="!!item.unit">{{item.unit}}</span>
                  </el-option>
                </el-select>
                <el-input v-else :disabled="item.disabled"  :prop="item.name" v-model="data[`${item.name}`]"  :placeholder="item.label">
                  <span v-if="!!item.unit" slot="suffix">{{item.unit}}</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item  v-for="(item,index_b1) in  rightList[boxTitle]"
                             :key="index_b1"
                             :label="item.label"
                             :prop="item.name"
              >
                <el-select  v-if="options[item.name]"
                            placeholder="请选择"
                            v-model="data[`${item.name}`]"
                >
                  <el-option v-for="child in options[item.name]"
                             :key="child"
                             :label="`${child} ${item.unit}`" :value="child">
                    <span style="float: left" >{{ child===''?'等待数据加载中...':child }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;padding-right:5px"
                          v-if="!!item.unit">{{item.unit}}</span>
                  </el-option>
                </el-select>
                <el-input v-else
                          :prop="item.name"
                          :placeholder="item.label"
                          v-model="data[`${item.name}`]"
                >
                  <span v-if="!!item.unit" slot="suffix">{{item.unit}}</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.closeAddModel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <div id="rightContain" style="z-index: 5000">
      <image-card
          v-for="image in images"
          :key="image.source"
          :source="image.source"
          :info="image.info"
          @onClose="closeImage"
          class="imageCard">
      </image-card>
    </div>
  </div>

</template>

<script>
import noteCard from "@/components/noteCard";
import imageCard from "@/components/imageCard";
import {mapMutations, mapState} from "vuex";
import {Message} from "element-ui";

export default {
  name: "formDialog",
  props:['title','modelParam','modelData'],
  data(){
    /**
     * 检查 葫芦的三个参数是否都已填完，满足条件则获取葫芦参数
     * @param rule
     * @param value
     * @param callback
     */
    const checkForHuluList = (rule, value, callback) => {
        if(!!this.data.P12&&!!this.data.P10&&!!this.data.P1){//获取葫芦列表条件已满足
          this.getHuluList();
        }
        callback();
    }
    const checkForHuluParam = (rule, value, callback) => {
      if(!!this.data.P12&&!!this.data.P13){//获取葫芦参数条件已满足
        this.getHuluParam();
      }
      callback();
    }
    const checkProjectName = (rule, value, callback) => {
      if(value===''){
        callback();
      }
      this.$api.checkpjname(value).then((usable)=>{
        if (!usable){
          callback(new Error('项目号重复，请重新输入！'));
        }else {
          callback();
        }
      });
    }
    const validLimit =(rule,value,callback)=>{
      const floorLimit = this.checkGreater(Number(value),3000);
      if (floorLimit || Number(value) === 0){
        callback();
      }else {
        callback(new Error());
      }
    }
    const upperZero =(rule,value,callback)=>{
      const floorLimit = this.checkGreater(Number(value),0);
      if (floorLimit){
        callback();
      }else {
        callback(new Error());
      }
    }
    const validP4 = (rule,value,callback)=>{
      if (value==='') callback();
      else {
        const conditionP6 = this.modelData.P6&&Number(this.modelData.P6)>=0;
        const conditionP7 = this.modelData.P7&&Number(this.modelData.P7)>=0;
        const conditionP8 = this.modelData.P8&&Number(this.modelData.P8)>=0;
        if (!conditionP6){
          this.$refs['modelForm'].validateField('P6');
        }
        if (!conditionP7){
          this.$refs['modelForm'].validateField('P7');
        }
        if (!conditionP8){
          this.$refs['modelForm'].validateField('P8');
        }
        if (conditionP6&&conditionP7&&conditionP8){
          if (Number(this.modelData.P4)>=Number(this.modelData.P6)*Number(this.modelData.P8)+Number(this.modelData.P7)+1000){
            callback();
          }else {
            callback(new Error());
          }
        }
      }

    }
    const validToP4 = (rule,value,callback)=>{
      if (!value) callback();
      else {
          if(this.modelData.P4&&Number(this.modelData.P4)>0){
            this.$refs['modelForm'].validateField('P4');
            callback();
          }else {
            callback();
          }
      }
    }
    return {
      data:{},
      notes:[],
      options:{},
      boxes:[],
      leftList:{},
      rightList:{},
      images:[],
      rules: {
        P12: [
          { required: true, message: '请选择葫芦品牌', trigger: 'blur' },
          { validator: checkForHuluList, trigger: 'change' },
          { validator: checkForHuluParam, trigger: 'change' },
        ],
        P13: [
          { required: true, message: '请选择葫芦型号', trigger: 'blur' },
          { validator: checkForHuluParam, trigger: 'change' },
        ],
        P10: [
          { validator: checkForHuluList, trigger: 'change' },
          { required: true, message: '请选择小车运行', trigger: 'blur' },
        ],
        P1: [
          { required: true, message: '请选择载荷', trigger: 'blur' },
          { validator: checkForHuluList, trigger: 'change' }
        ],
        P4:[
          { required: true, message: '请填写型轨总长', trigger: 'blur' },
          { validator: upperZero,message:'型轨总长必须大于0', trigger: 'blur' },
          { validator: validP4,message:'不满足约束条件!', trigger: 'change' }
        ],
        P6:[
          { required: true, message: '请填写中间跨数量', trigger: 'blur' },
          { validator: upperZero,message:'中间跨数量必须大于0', trigger: 'blur' },
          { validator: validToP4,message:'不满足约束条件', trigger: 'blur' }
        ],
        P7:[
          { required: true, message: '请填写首跨立柱间距', trigger: 'blur' },
          { validator: validLimit,message: '必须大于等于3000',trigger: 'blur' },
          { validator: upperZero,message:'必须大于等于3000', trigger: 'blur' },
          { validator: validToP4,message:'不满足约束条件!', trigger: 'blur' }
        ],
        P8:[
          { required: true, message: '请填写中间跨立柱间距', trigger: 'blur' },
          { validator: validLimit,message: '必须大于等于3000或为0', trigger: 'blur' },
          { validator: validToP4,message:'不满足约束条件!', trigger: 'blur' }
        ],
        P14:[
          { required: true, message: '请填写轨道系统', trigger: 'blur' },
        ],
        P15:[
          { required: true, message: '请填写立柱横梁', trigger: 'blur' },
        ],
        P2:[
          { required: true, message: '请填写跨度', trigger: 'blur' },
          { validator: upperZero,message:'跨度必须大于0', trigger: 'blur' },
        ],
        P3:[
          { required: true, message: '请填写梁下高度', trigger: 'blur' },
          { validator: upperZero,message:'梁下高度必须大于0', trigger: 'blur' },
        ],
        P5:[
          { required: true, message: '请填写主梁数量', trigger: 'blur' },
          { validator: upperZero,message:'主梁数量必须大于0', trigger: 'blur' },
        ],
        P9:[
          { required: true, message: '请选择大车运行', trigger: 'blur' },
        ],
        P11:[
          { required: true, message: '请选择大车运行供电', trigger: 'blur' },
        ],
        P16:[
          { required: true, message: '请选择小车运行供电', trigger: 'blur' },
        ],
        ProjectName:[
          { required: true, message: '请填写项目号', trigger: 'blur' },
          { validator: checkProjectName, trigger: 'blur' }
        ],
        IsDrawing:[{ required: true, message: '请选择工程图', trigger: 'blur' },],
        IsQuotation:[{ required: true, message: '请选择报价图', trigger: 'blur' },]




      }
    }
  },
  methods:{
    confirm() {
      this.$refs["modelForm"].validate(async (valid)=>{
        if (valid){
          const username = localStorage.getItem('username');
          const projectName = this.data.ProjectName
          this.data.UserType = sessionStorage.getItem('userType')??'-1';
          this.data.MailBox = sessionStorage.getItem('mailBox')??'-1';
          this.data.UserName = username;
          this.data.type = this.modelType;
          const data = await this.$api.postModel(this.modelType,username,projectName, this.data);
          if (data.status){
            Message.success('提交模型数据成功！');
          }else {
            this.$emit('clearModelData');
            Message.error(data.msg);
          }
          for (const key of Object.keys(data)) {
            data[key] = '';
          }
          this.closeAddModel();
        }
      })
    },
    /**
     * 增加便签
     * @param title {string} 便签标题
     * @param info {Array<{label:value,value:value}>}标签详情
     */
    addNote(title,info){
      if (this.notes.length===3) this.notes.shift();
      this.notes.push({title,info});
    },
    /**
     * 增加图片
     * @param source {string} 图片地址
     * @param info {string} 图片介绍
     */
    addImage(source,info){
      if (this.images.length===2) this.images.shift();
      const image = {source,info};
      this.images.push(image);
    },
    closeNote(title){
      this.notes = this.notes.filter(note=>note.title!==title);
    },
    closeImage(source){
      this.images = this.images.filter(image=>image.source!==source);
    },
    openModelImages(){
      for (const source of this.modelImages) {
        this.addImage(source,this.modelType);
      }
    },
    initView(modelParam){
      this.boxes = [];
      this.leftList = {};
      this.rightList ={};
      this.options = [];
      for (const box of modelParam) {
        this.boxes.push(box.label);
        this.$set(this.leftList,box.label,box.childrenLeft);
        this.$set(this.rightList,box.label,box.childrenRight);
        for (const child of box.childrenLeft) {
          if (child.selectValue){
            this.$set(this.options,child.name,child.selectValue);
          }
        }
        for (const child of box.childrenRight) {
          if (child.selectValue){
            this.$set(this.options,child.name,child.selectValue);
          }
        }
      }
    },
    checkLess(value,max){return value <= max;},
    checkGreater(value,min){return value >= min;},
    /**
     * 重置表单，重新获取模型参数，重新加载模型对象
     */
    handlerRefresh(){
      this.$emit('refresh');
    },
    async getHuluList(){
      const data = await this.$api.hllist(this.data.P12,this.data.P10,this.data.P1);
      const huLuList = data.type;
      console.log(huLuList);
      this.$set(this.options,'P13',huLuList);
    },
    async getHuluParam(){
      console.log('获取葫芦参数');
      const huLuData = await this.$api.hldata(this.data.P12,this.data.P13);
      const source =`http://${huLuData['img']}`;
      this.addImage(source,`${this.data.P13}`);
      Reflect.deleteProperty(huLuData,'img');
      let infos = [];
      infos.push({label:'型号',value:this.data.P13});
      for (const key of Object.keys(huLuData)) {
        const info = {label:key,value:huLuData[key]??''}
        infos.push(info);
      }
      this.addNote(`${this.data.P12}`,infos);
    },
    ...mapMutations(['closeAddModel'])
  },
  watch:{
    modelParam:{
      immediate:true,
      handler(val){
        console.log('参数改变了！');
        this.initView(val);
      }

    },
    modelData:{
      immediate:true,
      handler(val){
        this.data = val;
      }
    },
    modelImages(){
      this.openModelImages();
    }
  },
  computed:{
    ...mapState(['openAddModel','modelType',"modelImages"])
  },
  components:{
    noteCard,
    imageCard,
  },
  updated() {
    console.log('视图更新！');
  }
}
</script>

<style>
#formDialog_root{
  display: flex;
  flex-flow: row nowrap;
  position: relative;
}
#formDialog_root ::-webkit-scrollbar{
  width: 7px;
}
#formDialog_root ::-webkit-scrollbar-track{
  border: 1px;
  -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.8);
  border-radius:10px;
}
#formDialog_root ::-webkit-scrollbar-thumb {
  width: 4px;
  border-radius:10px;
  background:linear-gradient(to bottom,rgba(108, 219, 235,.6),rgba(108, 219, 235,.5),rgba(108, 219, 235,.6));
}
#formDialog_root .el-select{
  width: 180px;
}
#formDialog_root .el-input{
  width: 180px;
}
#formDialog_root .el-dialog__header{
  background: #ecf0f1;
  border-bottom: 1px rgba(220,223,230,.7) solid;
}
#formDialog_root .el-dialog__footer{
  background: #ecf0f1;
  border-top: 1px rgba(220,223,230,.9) solid;
}
#formDialog_root .el-dialog__body{
  backdrop-filter: blur(3rem);
  background: rgb(225, 229, 230);
}
#formDialog{
  border-radius: 6px;
  z-index: 2000;
}
#formDialog label.el-form-item__label{
  text-align: right;
  font-size: 12px !important;
  font-weight: normal !important;
}
#formDialog .el-form{
  width: 640px;
}
#formDialog .el-form-item{
  margin-bottom: 6px !important;
}
#formDialog .el-row{
  z-index: 2001;
  width: 640px;
}
#leftContain{
  z-index: 5000!important;
  height: 750px;
  width: 28.5%;
  padding: 10px;
  box-sizing: border-box;
  /*width: calc((100% - 770px) / 2);*/
  display: flex;
  flex-direction: column;
  align-items: center;
}
#rightContain{
  z-index: 5000!important;
  height: 780px;
  width: 28.5%;
  box-sizing: border-box;
  margin-left: calc(50% + 385px - (100% - 770px) / 2);
  /*width: calc((100% - 763px) / 2);*/
  display: flex;
  flex-direction: column;
  align-items: center;
}
#leftContain .noteCard,#rightContain .imageCard{
  margin-top: 10px;
  max-width: 90%;
  max-height: 385px;
}
#formDialog_root .el-image-viewer__wrapper{
  z-index: 9999!important;
}

#formDialog .form_box::before{
  font-size: 12px;
  font-style: inherit;
  padding: 8px 8px;
  margin-top: -22px;
  margin-bottom: 5px;
  font-weight: 600;
  content: attr(title);/*css数据属性*/
}
#formDialog .form_box{
  background:rgba(251,253,252,.75);
  border: none;
  backdrop-filter: blur(2rem);
  box-shadow: 0 2px 3px rgba(0, 0, 0, .12), 0 0 4px rgba(0, 0, 0, .04);
  border-radius: 15px;
  padding: 0 8px 5px;
  width:100%;
}
#formDialog .form_box:first-of-type{
  margin-top: 5px;
}
#formDialog .form_box:not(:first-of-type){
  margin-top: 39px;
}
.el-select-dropdown__wrap{/*去掉下拉框的滑动条*/
  overflow-y: hidden;
}
#formDialog .titleBtn{
  background: transparent;
  border: none;
  padding: 0 3px;

}


</style>
